import React, { useRef, useCallback, useState, useEffect } from 'react';
import { Bold, Italic, Underline } from 'lucide-react';

export default function MiniRichText({ value, onChange, placeholder }) {
    const editorRef = useRef(null);
    const [focused, setFocused] = useState(false);
    const internalChange = useRef(false);

    useEffect(() => {
        if (editorRef.current && !internalChange.current) {
            if (editorRef.current.innerHTML !== (value || '')) {
                editorRef.current.innerHTML = value || '';
            }
        }
        internalChange.current = false;
    }, [value]);

    const handleInput = useCallback(() => {
        if (editorRef.current) {
            internalChange.current = true;
            onChange(editorRef.current.innerHTML);
        }
    }, [onChange]);

    const execFormat = (cmd) => {
        document.execCommand(cmd, false, null);
        editorRef.current?.focus();
        handleInput();
    };

    const handlePaste = (e) => {
        e.preventDefault();
        const text = e.clipboardData.getData('text/plain');
        document.execCommand('insertText', false, text);
    };

    return (
        <div className={`border rounded-lg transition-colors ${focused ? 'border-teal-400 ring-1 ring-teal-100' : 'border-slate-200'}`}>
            {focused && (
                <div className="flex gap-0.5 px-1.5 py-1 border-b border-slate-100 bg-slate-50 rounded-t-lg">
                    <button
                        type="button"
                        onMouseDown={e => { e.preventDefault(); execFormat('bold'); }}
                        className="w-6 h-6 flex items-center justify-center rounded hover:bg-slate-200 text-slate-600"
                        title="Gras"
                    >
                        <Bold className="w-3 h-3" strokeWidth={2.5} />
                    </button>
                    <button
                        type="button"
                        onMouseDown={e => { e.preventDefault(); execFormat('italic'); }}
                        className="w-6 h-6 flex items-center justify-center rounded hover:bg-slate-200 text-slate-600"
                        title="Italique"
                    >
                        <Italic className="w-3 h-3" strokeWidth={2.5} />
                    </button>
                    <button
                        type="button"
                        onMouseDown={e => { e.preventDefault(); execFormat('underline'); }}
                        className="w-6 h-6 flex items-center justify-center rounded hover:bg-slate-200 text-slate-600"
                        title="Souligne"
                    >
                        <Underline className="w-3 h-3" strokeWidth={2.5} />
                    </button>
                </div>
            )}
            <div
                ref={editorRef}
                contentEditable
                suppressContentEditableWarning
                onInput={handleInput}
                onFocus={() => setFocused(true)}
                onBlur={() => setFocused(false)}
                onPaste={handlePaste}
                data-placeholder={placeholder}
                className="px-2 py-1.5 text-xs min-h-[28px] outline-none empty:before:content-[attr(data-placeholder)] empty:before:text-slate-300"
            />
        </div>
    );
}
